import { Component, OnInit, NgZone, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { NgxUiLoaderService, Loader, SPINNER, POSITION, PB_DIRECTION } from 'ngx-ui-loader';
import { ApiService } from '../../../_services/api.service';
import { first } from 'rxjs/operators';
declare var $: any;

@Component({
  selector: 'app-reports-list',
  templateUrl: './cnss-reports-list.component.html',
  styleUrls: ['./cnss-reports-list.component.scss']
})
export class CnssReportsListComponent implements OnInit {

  reportData: any;
  response: any;
  cnssreportList: any;
  dtsreportList: any;
  reSubmitData: any;
  paymentSuccess: any;
  accountDetails: any;
  reportStatus: string;
  currentUser: any;
  constructor(private router: Router,
    private ngZone: NgZone,
    private ngxUiLoaderService: NgxUiLoaderService,
    private api: ApiService) {

    if (this.router.getCurrentNavigation().extras.state) {
      this.reportData = this.router.getCurrentNavigation().extras.state.data;
      this.reSubmitData = this.router.getCurrentNavigation().extras.state.resubmitData;
      this.paymentSuccess = this.router.getCurrentNavigation().extras.state.payment_success;
      if (this.paymentSuccess == 1) {
        setTimeout(() => {
          $('#paymentSuccess').modal('show');
        }, 500)
      }
      console.log(this.reportData, "Line29")
      console.log(this.reSubmitData, "Line 30")
    }

    this.getAccountData();
    const data = localStorage.getItem('currentUserDetails');
    if (data) {
      this.accountDetails = JSON.parse(data);
    }
    this.reportStatus = '5';
    console.log("46", this.reportStatus)
  }

  ngOnInit() {

    AOS.init({
      disable: function () {
        var maxWidth = 600;
        return window.innerWidth < maxWidth;
      }
    });
    console.log('reportStatus', this.reportStatus)
    // this.getCnssReport();
    this.getDtsReport();
  }


  getAccountData() {
    console.log("442 get employer details")
    this.ngxUiLoaderService.start();
    this.api.getAccountDetails().pipe(first())
      .subscribe(res => {
        this.ngxUiLoaderService.stop();
        this.response = res.results;
        if (res.status == 200) {
          console.log("88", res)
          this.accountDetails = this.response;
          if (this.response.current_user == 1) {
            this.currentUser = this.response.current_user;

          } else if (this.response.employee.current_user == 2) {
            this.currentUser = this.response.employee.current_user;

          }



          if (this.currentUser == 1) {

            const data = JSON.stringify(this.accountDetails);
            localStorage.setItem('currentUserDetails', data);
          } else if (this.currentUser == 2) {
            const data = JSON.stringify(this.accountDetails.employee);
            localStorage.setItem('currentUserDetails', data);
            console.log("117", data)
          }

        } else {
          console.log("no result")
          // this.snackBar.open(res.message, "OK", {
          //   duration: 5000,
          // });
        }
      },
        error => {
          console.log("errorrrrrrrrr")
          this.ngxUiLoaderService.stop();
        });
    console.log("no result")
  }

  onFilterChange() {
    console.log('reportStatus', this.reportStatus)
    this.reportData = null;
    this.reSubmitData = null;
    // this.getCnssReport();
    this.getDtsReport();
  }
  gotoUrl(type: any) {
    if (type == 1) {
      this.router.navigate(['/cnss-reports'], { state: { data: '3' } });

    } else {
      this.router.navigate(['/cnss-reports'], { state: { data: '4' } });
    }
  }

  getCnssReport() {
    console.log("71")
    this.ngxUiLoaderService.start();

    let data = {
      entityType: this.reportStatus
    }
    console.log("73", data)
    if (data) {
      this.api.getCnssreportList(data).pipe(first())
        .subscribe(res => {
          this.ngxUiLoaderService.stop();
          this.response = res;
          if (this.response.status == 200) {
            this.cnssreportList = this.response.result;
            console.log("this.cnssreportList", this.cnssreportList);

            if (this.reportData || this.reSubmitData) {
              $('#successModal').modal('show');
            }
          } else {

          }
        },
          error => {
            this.ngxUiLoaderService.stop();
          });
    }

  }


  getDtsReport() {
    console.log("71")
    this.ngxUiLoaderService.start();

    let data = {
      entityType: this.reportStatus
    }
    console.log("73", data)
    if (data) {
      this.api.getDtsreportList(data).pipe(first())
        .subscribe(res => {
          this.ngxUiLoaderService.stop();
          this.response = res;
          if (this.response.status == 200) {
            this.dtsreportList = this.response.result;
            console.log("this.dtsreportList", this.dtsreportList);


            if (this.reportData || this.reSubmitData) {
              $('#successModal').modal('show');
            }
          } else {

          }
        },
          error => {
            this.ngxUiLoaderService.stop();
          });
    }

  }

  getViewofReports(cnss_uuid: any, cnamgs_uuid: any, status) {
    // localStorage.setItem('reportid', cnss_uuid)
    console.log(cnss_uuid)
    console.log("68", status)
    if (status == 'rejectedCnss') {
      console.log("70")
      this.router.navigate(['cnss-reports', cnss_uuid, cnamgs_uuid]);
    } else {
      this.router.navigate(['/cnss-report-view', cnss_uuid, cnamgs_uuid]);
    }

  }
  openDoc() {
    this.ngxUiLoaderService.start();
    this.api.getCnssPdf().pipe(first())
      .subscribe(data => {
        this.ngxUiLoaderService.stop();
        console.log("263", data)
        if (data.status == 200) {
          window.open(data.imagePath, '_blank');
        } else {
          // this.snackBar.open(data.message, "OK", {
          //   duration: 5000,
          // });
        }
      },
        error => {
          this.ngxUiLoaderService.stop();
        });
  }

}
